import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";

export const StandardSpacerElementMixin = {
  extends: DynamicElementMixin,
  elementPanelSettings: {
    tags: ["spacer", "gap", "space"],
    displayName: "Spacer",
    displayIcon: "gap",
    elementType: "element",
    elementGroup: "general",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": 1,
      "default.layout-height": 1,
    }),
  ],
  computed: {
    myHeight() {
      const calculatedHeight = this.getOptionValue(LayoutHeight);
      if (calculatedHeight === "hug") {
        return 1;
      } else if (calculatedHeight === "fill") {
        return "fill";
      }

      return calculatedHeight;
    },
    myWidth() {
      const calculatedWidth = this.getOptionValue(LayoutWidth);
      if (calculatedWidth === "hug") {
        return 1;
      } else if (calculatedWidth === "fill") {
        return "fill";
      }

      return calculatedWidth;
    },
  },
};
